import { useCallback, useState } from 'react';

import {
  mixpanelInit,
  mixpanelSetConfig,
  mixpanelTrack,
  mixpanelTrackPageView,
} from '../utils/TrackingData/utils';
import type { EventMetaData } from '../utils/TrackingData/types';

const useEventTracking = () => {
  const [hasInitialised, setHasInitialised] = useState(false);

  const initialiseTracking = useCallback((): void => {
    mixpanelInit();
    mixpanelSetConfig();
    setHasInitialised(true);
  }, []);

  const trackPageView = useCallback((): void => {
    mixpanelTrackPageView();
  }, []);

  const trackEvent = useCallback(
    (eventName: string, metaData?: EventMetaData): void => {
      mixpanelTrack(eventName, metaData);
    },
    []
  );

  return {
    trackEvent,
    trackPageView,
    initialiseTracking,
    hasInitialised,
  };
};

export default useEventTracking;
